// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zWsjn","paragraph":"styles_paragraph__VqPis"};